import { useEffect, useState } from "react";
import { Loader2, Download } from "lucide-react";
import api from "@/lib/api";

const PERIODS = [["all", "Alles"], ["month", "Deze maand"], ["year", "Dit jaar"]];

export default function Churn() {
  const [d, setD] = useState(null);
  const [period, setPeriod] = useState("all");

  useEffect(() => {
    setD(null);
    api.get("/admin/churn", { params: { period } }).then((r) => setD(r.data)).catch(() => {});
  }, [period]);

  const exportCsv = () => {
    if (!d?.recent?.length) return;
    const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
    const header = ["Datum", "Naam", "E-mail", "Reden", "Toelichting"];
    const rows = d.recent.map((r) => [r.created_at || "", r.name || "", r.email || "", r.label || "", r.reason_text || ""].map(esc).join(","));
    const csv = [header.map(esc).join(","), ...rows].join("\n");
    const url = URL.createObjectURL(new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" }));
    const a = document.createElement("a");
    a.href = url; a.download = `slackr-feedback-${period}.csv`;
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="sa-churn">
      <div className="flex flex-wrap items-center gap-2 mb-5">
        <div className="flex gap-1 bg-white border border-slate-200 rounded-xl p-1">
          {PERIODS.map(([id, label]) => (
            <button key={id} data-testid={`churn-period-${id}`} onClick={() => setPeriod(id)}
              className={`rounded-lg px-3 py-1.5 text-sm font-bold ${period === id ? "bg-indigo-600 text-white" : "text-slate-500 hover:bg-slate-100"}`}>{label}</button>
          ))}
        </div>
        <button data-testid="churn-export" onClick={exportCsv} disabled={!d?.recent?.length}
          className="ml-auto flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-bold bg-white border border-slate-200 hover:bg-slate-50 disabled:opacity-40">
          <Download className="w-4 h-4" /> Exporteer CSV
        </button>
      </div>

      {!d ? <div className="flex items-center gap-2 text-slate-400 py-12"><Loader2 className="w-5 h-5 animate-spin" /> Laden…</div> : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5">
            <div className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm">
              <p className="text-2xl font-head font-black text-rose-600">{d.total}</p>
              <p className="text-xs text-slate-500 mt-1">Opgeheven accounts (met reden)</p>
            </div>
          </div>

          <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 mb-5">
            <p className="font-head font-black mb-3">Vertrekredenen</p>
            {d.breakdown.length === 0 ? <p className="text-sm text-slate-400">Nog geen feedback in deze periode.</p> : (
              <div className="space-y-2.5">
                {d.breakdown.map((b) => {
                  const max = Math.max(1, ...d.breakdown.map((x) => x.count));
                  return (
                    <div key={b.reason} data-testid={`churn-bar-${b.reason}`} className="flex items-center gap-3">
                      <span className="w-40 text-sm text-slate-600 shrink-0">{b.label}</span>
                      <div className="flex-1 h-6 bg-slate-100 rounded-lg overflow-hidden">
                        <div className="h-full bg-indigo-500 rounded-lg" style={{ width: `${(b.count / max) * 100}%` }} />
                      </div>
                      <span className="w-8 text-right font-bold text-sm">{b.count}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-2 overflow-x-auto">
            <table className="w-full text-sm min-w-[640px]">
              <thead>
                <tr className="text-left text-slate-400 text-xs uppercase tracking-wide border-b border-slate-200">
                  <th className="py-3 px-2">Datum</th><th className="px-2">Naam</th><th className="px-2">Reden</th><th className="px-2">Toelichting</th>
                </tr>
              </thead>
              <tbody>
                {d.recent.map((r, i) => (
                  <tr key={i} className="border-b border-slate-100 hover:bg-slate-50">
                    <td className="py-3 px-2 text-slate-500 text-xs">{r.created_at ? new Date(r.created_at).toLocaleString("nl-NL") : "—"}</td>
                    <td className="px-2 font-bold">{r.name || "—"}</td>
                    <td className="px-2 text-slate-600">{r.label}</td>
                    <td className="px-2 text-slate-500">{r.reason_text || "—"}</td>
                  </tr>
                ))}
                {d.recent.length === 0 && <tr><td colSpan={4} className="py-8 text-center text-slate-400">Nog geen feedback.</td></tr>}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
